import styled from 'styled-components'
import get from 'lodash/get'

const getColor = ({theme}) => get(theme, 'progressBar.color', '#CCCCCC')
const getActiveColor = ({theme}) => get(theme, 'progressBar.activeColor', '#000000')
const getFontFamily = ({theme}) => get(theme, 'progressBar.fontFamily', get(theme, 'font.boldFamily', 'inherit'))
const getFontSize = ({theme}) => get(theme, 'progressBar.fontSize', '12px')
const getFontWeight = ({theme}) => get(theme, 'progressBar.fontWeight', 700)
const getItemBorder = ({theme}) => get(theme, 'progressBar.item.default.border', '2px solid #CCCCCC')
const getItemFontSize = ({theme}) => get(theme, 'progressBar.item.fontSize', '14px')
const getActiveItemColor = ({theme}) => get(theme, 'progressBar.item.active.color', '#000000')
const getActiveItemBorder = ({theme}) => get(theme, 'progressBar.item.active.border', '2px solid #000000')

const ProgressBarView = styled.ul`
  margin: 0 0 35px 0;
  padding: 0;
  list-style: none outside none;
  display: flex;
  align-items: center;
  counter-reset: list-number;
  font-family: ${getFontFamily};
  font-style: normal;
  font-weight: ${getFontWeight};
  font-size: ${getFontSize};
  color: ${getColor};
  text-transform: capitalize;
`

const ProgressBarItem = styled.li`
  display: flex;
  align-items: center;
  margin-left: 8px;

  &:first-child {
    margin-left: 0;
  }

  &:before {
    font-size: ${getItemFontSize};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 4px;
    width: ${({theme}) => get(theme, 'progressBar.item.width', '19px')};
    height: ${({theme}) => get(theme, 'progressBar.item.height', '19px')};
    background: ${({theme}) => get(theme, 'progressBar.item.default.backgroundColor', '#ffffff')};
    border: ${getItemBorder};
    border-radius: 50%;
    counter-increment: list-number;
    content: counter(list-number);
    box-sizing: border-box;
    flex-shrink: 0;
  }

  &.active {
    color: ${getActiveColor};

    &:before {
      border: ${getActiveItemBorder};
      color: ${getActiveItemColor};
      background: ${({theme}) => get(theme, 'progressBar.item.active.backgroundColor', '#ffffff')};
    }
  }
`

const SeparatorBarItem = styled.li`
  margin-left: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
`

const BarItem = styled.div`
  width: 4px;
  height: 2px;
  background-color: ${getColor};
`

export {ProgressBarView, ProgressBarItem, SeparatorBarItem, BarItem}
